import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import Button from '@mui/material/Button';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import { clientHubRefer } from '@/components/client-hub/api';
import style from '@/components/referral/style.module.scss';
import {
  EMAIL_FORM_ERR_FR,
  ENTER_CHARS_FORM_ERR,
  ENTER_VALID_FORM_ERR,
  FORM_ERRORS,
  NAME_FORM_ERR,
  NAME_FORM_ERR_FR,
} from '@/utils/constants';

type Inputs = {
  clientFullName: string;
  clientEmail: string;
  clientPhone: number;
  friendRelationship: string;
  friendName: string;
  friendEmail: string;
  friendPhone: number;
};

const ClientHubReferral = (props: {
  isMobile: boolean;
  activeSection: string;
  track: Function;
  lcode: string;
}) => {
  const { isMobile, activeSection, track, lcode } = props;
  const locale = 'en';

  const id = 'referral';

  const showSection = () => {
    if (isMobile) return activeSection === id;
    return true;
  };

  const {
    register,
    getValues,
    reset,
    trigger,
    formState: { errors },
  } = useForm<Inputs>({
    defaultValues: {
      clientFullName: '',
      clientEmail: '',
      clientPhone: null,
      friendRelationship: '',
      friendName: '',
      friendEmail: '',
      friendPhone: null,
    },
  });

  const [formDisplayed, setFormDisplayed] = useState('');
  const [caseId, setCaseId] = useState('');
  const [clientName, setClientName] = useState('');
  const [recipientName, setRecipientName] = useState('');
  let formSubmissionLock = false;

  const clickRefer = async () => {
    if (formSubmissionLock === true) {
      return;
    }
    formSubmissionLock = true;
    track('Click Refer');
    const formIsValid = await trigger();
    if (!formIsValid) {
      console.log('Errors found', errors);
      return;
    }
    const body = {
      lcode,
      client: {
        fullName: getValues('clientFullName'),
        phone: getValues('clientPhone'),
        email: getValues('clientEmail'),
      },
      friend: {
        relationship: getValues('friendRelationship'),
        name: getValues('friendName'),
        phone: getValues('friendPhone'),
        email: getValues('friendEmail'),
      },
      isAlreadyReferred: formDisplayed === 'received',
    };
    const response = await clientHubRefer(body);
    // TODO handle API errors
    if (response.status === 200) {
      setCaseId('true');
      formSubmissionLock = false;
    }
  };

  const resetForm = () => {
    reset();
    setClientName('');
    setRecipientName('');
    setCaseId('');
  };

  const copyToClipboard = (text: string) => {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'absolute';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      document.execCommand('copy') ? resolve(true) : reject();
      textArea.remove();
    });
  };

  const copyCaseId = () => copyToClipboard(`Referral id: ${caseId}`);

  return (
    <div style={{ display: showSection() ? 'block' : 'none' }}>
      <div id="success-modal" style={{ display: caseId ? 'flex' : 'none' }}>
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'lightgrey',
            opacity: '0.5',
            zIndex: 2000,
          }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            position: 'fixed',
            zIndex: 3000,
          }}
        >
          <div
            style={{
              width: '80%',
              minHeight: '10em',
              backgroundColor: 'white',
              borderRadius: '10px',
              padding: '20px',
              opacity: '1',
            }}
          >
            <h3 style={{ textTransform: 'none' }}>
              {formDisplayed === 'send'
                ? 'Thank you for your referral!'
                : 'Thank you for your letting us know!'}
            </h3>
            <br />
            <div>
              {formDisplayed === 'send'
                ? `We'll reach out to you once ${recipientName} has moved in.`
                : "We'll confirm your information and process the referral."}
            </div>
            <div style={{ display: 'none' }}>
              <br />
              <div>
                <span>
                  <b>Referral id: {caseId}</b>
                </span>{' '}
                &nbsp;
                <span
                  onClick={() => copyCaseId()}
                  style={{ cursor: 'pointer' }}
                >
                  <ContentCopyOutlinedIcon fontSize={'small'} />
                </span>
              </div>
              <div>Submitted by: {clientName}</div>
              <div>Recipient: {recipientName}</div>
              <br />
            </div>
            <br />
            <div>Talk soon!</div>
            <br />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  cursor: 'pointer',
                  border: '2px solid lightgrey',
                  borderRadius: '5px',
                  padding: '8px 16px',
                }}
                onClick={() => {
                  resetForm();
                }}
              >
                Close
              </div>
            </div>
          </div>
        </div>
      </div>

      <h3
        id="referral"
        style={{ textTransform: 'none', backgroundColor: 'aliceblue' }}
      >
        Referrals
      </h3>
      <div>
        {' '}
        Refer a friend to Access Storage and <b>earn up to $100</b> when they
        move in. Just fill in the form below.
      </div>
      <br />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          margin: '20px 0',
        }}
      >
        <div
          style={{
            padding: '10px',
            margin: '0 10px',
            textAlign: 'center',
            width: '50%',
            backgroundColor:
              formDisplayed === 'send'
                ? 'rgba(240, 248, 255)'
                : 'rgba(240, 248, 255, 0.5)',
            boxShadow:
              formDisplayed === 'send'
                ? 'lightblue 0px 0px 24px -16px inset'
                : '',
            borderBottom: formDisplayed === 'send' ? '2px solid lightblue' : '',
          }}
          onClick={() =>
            setFormDisplayed(formDisplayed === 'send' ? '' : 'send')
          }
        >
          Send a referral{' '}
        </div>
        <div
          style={{
            padding: '10px',
            margin: '0 10px',
            textAlign: 'center',
            width: '50%',
            backgroundColor:
              formDisplayed === 'received'
                ? 'rgba(240, 248, 255)'
                : 'rgba(240, 248, 255, 0.5)',
            boxShadow:
              formDisplayed === 'received'
                ? 'lightblue 0px 0px 24px -16px inset'
                : '',
            borderBottom:
              formDisplayed === 'received' ? '2px solid lightblue' : '',
          }}
          onClick={() =>
            setFormDisplayed(formDisplayed === 'received' ? '' : 'received')
          }
        >
          I was referred{' '}
        </div>
      </div>
      <div
        style={{ display: 'flex', justifyContent: 'center', margin: '10px 0' }}
      />
      <form style={{ display: formDisplayed === '' ? 'none' : '' }}>
        <div>
          <b>Your contact information</b>
        </div>
        <div>
          <div>
            <div>
              <label key="name" className={style.formLabel}>
                Full name*
              </label>
              <div>
                <input
                  type="text"
                  style={{
                    width: '100%',
                    marginBottom: '10px',
                    boxSizing: 'border-box',
                    background: 'rgba(224, 225, 227, 0.14)',
                    border: '1px solid rgba(2, 35, 94, 0.2)',
                    borderRadius: '4px',
                  }}
                  {...register('clientFullName', {
                    required:
                      locale === 'en' ? NAME_FORM_ERR : NAME_FORM_ERR_FR,
                    pattern: {
                      value: /^[a-zA-Z\s]{0,50}$/,
                      message:
                        locale === 'en'
                          ? ENTER_CHARS_FORM_ERR
                          : NAME_FORM_ERR_FR,
                    },
                  })}
                />
                {errors.clientFullName?.message && (
                  <div className="error-msg text-end">
                    {errors.clientFullName?.message}
                  </div>
                )}
              </div>
            </div>
            <div>
              <label> Phone number on file*</label>
              <div>
                <input
                  type="tel"
                  id="phone"
                  style={{
                    width: '100%',
                    marginBottom: '10px',
                    boxSizing: 'border-box',
                    background: 'rgba(224, 225, 227, 0.14)',
                    border: '1px solid rgba(2, 35, 94, 0.2)',
                    borderRadius: '4px',
                  }}
                  {...register('clientPhone', {
                    required: 'Phone is required',
                    pattern: {
                      value: /^(?![01])[0-9]{10}$/,
                      message:
                        locale === 'en'
                          ? FORM_ERRORS.EN.ENTER_PHONE
                          : FORM_ERRORS.FR.PHONE,
                    },
                  })}
                />
                {errors.clientPhone?.message && (
                  <div className="error-msg text-end">
                    {errors.clientPhone?.message}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div>
            <label> Email</label>
            <div>
              <input
                type="email"
                id="email"
                style={{
                  width: '100%',
                  marginBottom: '10px',
                  boxSizing: 'border-box',
                  background: 'rgba(224, 225, 227, 0.14)',
                  border: '1px solid rgba(2, 35, 94, 0.2)',
                  borderRadius: '4px',
                }}
                {...register('clientEmail', {
                  required: false,
                  pattern: {
                    value: /^$|^\S+@\S+$/i,
                    message:
                      locale === 'en'
                        ? ENTER_VALID_FORM_ERR
                        : EMAIL_FORM_ERR_FR,
                  },
                })}
              />
            </div>
          </div>
        </div>
        <br />
        <div>
          <b>
            {formDisplayed === 'send'
              ? 'The referral information'
              : 'The information of the person who referred you'}
          </b>
        </div>
        <div>
          <div>
            <div className={style.formRow}>
              <label key="name" className={style.formLabel}>
                Relationship to you (friend, coworker, etc)*
              </label>
              <div>
                <input
                  type="text"
                  style={{
                    width: '100%',
                    marginBottom: '10px',
                    boxSizing: 'border-box',
                    background: 'rgba(224, 225, 227, 0.14)',
                    border: '1px solid rgba(2, 35, 94, 0.2)',
                    borderRadius: '4px',
                  }}
                  {...register('friendRelationship', {
                    required: 'Relationship required',
                  })}
                />
                {errors.friendRelationship?.message && (
                  <div className="error-msg text-end">
                    {errors.friendRelationship?.message}
                  </div>
                )}
              </div>
            </div>
            <div className={style.formRow}>
              <label key="name" className={style.formLabel}>
                Name*
              </label>
              <div>
                <input
                  type="text"
                  style={{
                    width: '100%',
                    marginBottom: '10px',
                    boxSizing: 'border-box',
                    background: 'rgba(224, 225, 227, 0.14)',
                    border: '1px solid rgba(2, 35, 94, 0.2)',
                    borderRadius: '4px',
                  }}
                  {...register('friendName', {
                    required: 'Name is required',
                    pattern: {
                      value: /^[a-zA-Z\s]{0,50}$/,
                      message:
                        locale === 'en'
                          ? ENTER_CHARS_FORM_ERR
                          : NAME_FORM_ERR_FR,
                    },
                  })}
                />
                {errors.friendName?.message && (
                  <div className="error-msg text-end">
                    {errors.friendName?.message}
                  </div>
                )}
              </div>
            </div>
            <div>
              <label> Phone number*</label>
              <div>
                <input
                  type="tel"
                  id="phone"
                  style={{
                    width: '100%',
                    marginBottom: '10px',
                    boxSizing: 'border-box',
                    background: 'rgba(224, 225, 227, 0.14)',
                    border: '1px solid rgba(2, 35, 94, 0.2)',
                    borderRadius: '4px',
                  }}
                  {...register('friendPhone', {
                    required: 'Phone is required',
                    pattern: {
                      value: /^(?![01])[0-9]{10}$/,
                      message:
                        locale === 'en'
                          ? FORM_ERRORS.EN.ENTER_PHONE
                          : FORM_ERRORS.FR.PHONE,
                    },
                  })}
                />
                {errors.friendPhone?.message && (
                  <div className="error-msg text-end">
                    {errors.friendPhone?.message}
                  </div>
                )}
              </div>
            </div>
            <div>
              <label> Email</label>
              <div>
                <input
                  type="email"
                  id="email"
                  style={{
                    width: '100%',
                    marginBottom: '10px',
                    boxSizing: 'border-box',
                    background: 'rgba(224, 225, 227, 0.14)',
                    border: '1px solid rgba(2, 35, 94, 0.2)',
                    borderRadius: '4px',
                  }}
                  {...register('friendEmail', {
                    required: false,
                    pattern: {
                      value: /^$|^\S+@\S+$/i,
                      message:
                        locale === 'en'
                          ? ENTER_VALID_FORM_ERR
                          : EMAIL_FORM_ERR_FR,
                    },
                  })}
                />
              </div>
            </div>
            <div style={{ display: 'flex', margin: '10px 0' }}>
              <div style={{ fontSize: 'small' }}>
                By submitting a referral I confirm I agree with the referral
                program terms in the FAQs section.
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '10px 0',
              }}
            >
              <Button
                variant="contained"
                style={{
                  backgroundColor: '#E2002D',
                  marginBottom: 12,
                  color: 'white',
                }}
                onClick={() => clickRefer()}
              >
                {formDisplayed === 'send' ? 'Refer' : 'Submit'}
              </Button>
            </div>
          </div>
        </div>
      </form>
      <hr />
      <br />
    </div>
  );
};

export default ClientHubReferral;
